import { IRecord } from "../types/schema"

type IProductLocation = IRecord<
  "product_locations",
  "name" | "warehouse" | "free_stock" | "specific_location"
>

export function getProductLocationPrioritized(
  locations: IProductLocation[],
  args: {
    defaultStockLocation: string
    branch?: { name: string; consignmentWarehouse?: { id: string } | null } | null
    warehouses?: IRecord<"warehouses">[]
    directDeliveryWarehouse?: IRecord<"warehouses"> | null
    defaultIntercoWarehouse?: IRecord<"warehouses"> | null
    directDelivery?: boolean
  },
  opts?: {
    isConsignment?: boolean
    isInterco?: boolean
    prioritize?: IRecord<"warehouses"> | null
    override?: IRecord<"warehouses"> | null
  },
) {
  const { defaultStockLocation, branch, defaultIntercoWarehouse, warehouses } = args
  const availableLocations = getFilteredProductLocations(locations, warehouses)

  if (opts?.override) {
    return availableLocations.find(l => l.warehouse?.id === opts.override?.id)
  }

  if (opts?.prioritize?.id) {
    const location = availableLocations.find(l => l.warehouse?.id === opts.prioritize?.id)
    if (location) {
      return location
    }
  }

  if (args?.directDelivery) {
    const location = availableLocations.find(
      location =>
        (args.directDeliveryWarehouse &&
          location.warehouse?.id === args.directDeliveryWarehouse.id) ||
        location.name.match(/direct/i),
    )
    if (location) {
      return location
    }
  }

  if (opts?.isConsignment) {
    const consignment = availableLocations.find(
      l => l.warehouse?.id === branch?.consignmentWarehouse?.id,
    )
    if (consignment) {
      return consignment
    }
  }
  const intercoWarehouse =
    !!defaultIntercoWarehouse &&
    availableLocations.find(l => l.warehouse?.id === defaultIntercoWarehouse.id)

  if (opts?.isInterco && intercoWarehouse) {
    return intercoWarehouse
  }

  const loc =
    availableLocations.find(
      item => item.name.toUpperCase() === defaultStockLocation.toUpperCase(),
    ) ??
    availableLocations.find(item => item.name.toUpperCase() === branch?.name.toUpperCase()) ??
    availableLocations.filter(l => l.warehouse?.id !== branch?.consignmentWarehouse?.id)[0] ??
    availableLocations[0]

  return loc
}

/**
 *
 * @param locations an array of product locations to be filtered
 * @param warehouses array of allowed warehouses, empty array = not filtered
 * @returns an array of product locations, will remove locations not part of the supplied warehouses
 * if warehouses has at least one value
 */
export function getFilteredProductLocations(
  locations: IProductLocation[],
  warehouses?: IRecord<"warehouses">[],
) {
  if (!warehouses || warehouses.length === 0) {
    return locations ?? []
  }
  const warehouseIds = warehouses.map(w => w.id)
  return (
    locations.filter(item => (item.warehouse ? warehouseIds.includes(item.warehouse.id) : false)) ??
    []
  )
}
